import { useEffect, useState } from 'react';
import { globalBus } from '../streams/wsBus';
import { useActionFeedback } from '../streams/useActionFeedback';

type BeeRow = [string, string, string, string, string, boolean];

export function BeeMonitorPanel() {
  const [rows, setRows] = useState<BeeRow[]>([]);
  const [workers, setWorkers] = useState(0);
  const { states, fire } = useActionFeedback(globalBus);

  useEffect(() => {
    const unsub = globalBus.subscribe((message) => {
      if (message.t === 'scene' && message.id === 'hivecore.bees') {
        setWorkers(message.body?.widgets?.find((w: any) => w.key === 'hive.workers.active')?.value ?? 0);
        setRows(message.body?.widgets?.find((w: any) => w.key === 'bees.health')?.rows ?? []);
      }
    });
    globalBus.sendIntent('scene.request', { id: 'hivecore.bees' });
    return unsub;
  }, []);

  const toggleBee = (name: string, enabled: boolean) =>
    fire(`bees.toggle.${name}`, 'bees.toggle', { name, enabled });
  const restartBee = (name: string) => fire(`bees.restart.${name}`, 'bees.restart', { name });

  return (
    <div className="panel">
      <header className="panel-header">
        <h2>Bee Monitor</h2>
        <span className="chip ok">{workers} active</span>
      </header>
      <table className="table">
        <thead>
          <tr>
            <th>Bee</th>
            <th>Role</th>
            <th>Status</th>
            <th>Latency</th>
            <th>Errors</th>
            <th colSpan={2}>Controls</th>
          </tr>
        </thead>
        <tbody>
          {rows.map(([name, role, status, latency, errors, enabled]) => (
            <tr key={name}>
              <td>{name}</td>
              <td>{role}</td>
              <td>{status}</td>
              <td>{latency}ms</td>
              <td>{errors}</td>
              <td>
                <button
                  data-state={states[`bees.toggle.${name}`] ?? 'idle'}
                  onClick={() => toggleBee(name, !enabled)}
                >
                  {enabled ? 'Disable' : 'Enable'}
                </button>
              </td>
              <td>
                <button
                  data-state={states[`bees.restart.${name}`] ?? 'idle'}
                  onClick={() => restartBee(name)}
                >
                  Restart
                </button>
              </td>
            </tr>
          ))}
          {rows.length === 0 && (
            <tr>
              <td colSpan={7} style={{ textAlign: 'center', padding: '24px', color: 'var(--muted)' }}>
                No bees streaming yet.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
